/* global $:false */

export default class SystembolagetAgeForm {
  static init () {
    Array.from($('.js-systembolaget-age-form__checkbox')).map((el) =>
      new SystembolagetAgeForm(el))
  }

  constructor (el) {
    this.el = $(el)
    this._findElements()
    this._setupBindings()
    this.el.removeAttr('disabled')
  }

  _findElements () {
    this.submitButton = $('.js-systembolaget-age-form__submit')
    this.submitForm = this.submitButton.closest('form')
  }

  _setupBindings () {
    this.el.change(event => this._enableOrDisableSubmitButton())
    this.submitButton.click(() => this._reloadPageAfterSuccessfulAjax())
  }

  _enableOrDisableSubmitButton () {
    this.submitButton.attr('disabled', !this.el.prop('checked'))
  }

  _reloadPageAfterSuccessfulAjax () {
    this.submitForm.on('ajax:success', event => {
      this.submitButton.attr('disabled', true)
      this._guard(this._guard(window.webkit != null ? window.webkit.messageHandlers : undefined, x1 => x1.setSystembolagetCookie), x => x.postMessage('setSystembolagetCookie'))
      window.location.reload()
    })
  }

  _guard (value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
  }
}
